;(function () {
  'use strict'

  angular
    .module('contrast.applications')
    .factory('ApplicationService', ApplicationService)

  function ApplicationService(
    $uibModal,
    $translate,
    ApplicationFactory,
    ErrorService,
    ServiceUtils
  ) {
    'ngInject'

    var service = {
      buildApplicationSettings: buildApplicationSettings,
      addDisplayNameToApp: addDisplayNameToApp,
      removeDisplayNameFromApp: removeDisplayNameFromApp,
      buildEnvironmentSettings: buildEnvironmentSettings,
      get: get,
      getApplicationBase: getApplicationBase,
      getFiltersCatalogs: getFiltersCatalogs,
      getFiltersByType: getFiltersByType,
      getApplicationsByFilter: getApplicationsByFilter,
      restoreBatch: restoreBatch,
      resetBatch: resetBatch,
      deleteBatch: deleteBatch,
      getAppGroups: getAppGroups,
      updateImportance: updateImportance,
      getApplicationsQuickFilters: getApplicationsQuickFilters,
      getShortApplicationsByFilter: getShortApplicationsByFilter,
      launchTagApplicationsModal: launchTagApplicationsModal,
      launchAppGroupModal: launchAppGroupModal,
      launchAppMergeModal: launchAppMergeModal,
      archivePrimaryApps: archivePrimaryApps,
      archiveNormalApps: archiveNormalApps
    }

    return service

    function buildApplicationSettings(app) {
      var form = {}
      form.displayName = app.name
      form.code = app.short_name
      form.url = app.override_url
      form.importance = app.importance
      form.notes = app.notes
      if (app.importance == 0) {
        form.importance_name = 'None'
      } else if (app.importance == 1) {
        form.importance_name = 'Low'
      } else if (app.importance == 2) {
        form.importance_name = 'Medium'
      } else if (app.importance == 3) {
        form.importance_name = 'High'
      } else if (app.importance == 4) {
        form.importance_name = 'Critical'
      }

      return form
    }

    function addDisplayNameToApp(apps) {
      angular.forEach(apps, function (app) {
        app.display_name = app.name
      })

      return apps
    }

    function removeDisplayNameFromApp(apps) {
      angular.forEach(apps, function (app) {
        delete app.display_name
      })

      return apps
    }

    function buildEnvironmentSettings(
      response,
      serversQuantityWithInstrumentationConflict
    ) {
      return {
        environment: response.environment,
        protection: response.protection,
        assessment: response.assessment,
        total_servers: response['total_servers'],
        servers_protection:
          response['servers_protection'] -
          serversQuantityWithInstrumentationConflict,
        servers_assessment: response['servers_assessment'],
        servers: response.servers,
        servers_with_protection: response.servers_with_protection
      }
    }

    function get(applicationId) {
      return ApplicationFactory.getApplication(
        applicationId,
        'license,compliance_policy'
      )
        .then(function (response) {
          return response.data.application
        })
        .catch(ErrorService.processError)
    }

    function getApplicationBase(includeModules, validLanguages) {
      return ApplicationFactory.getApplicationBase(
        includeModules,
        validLanguages
      )
        .then(ServiceUtils.handleResolve('data.applications'))
        .catch(ServiceUtils.handleError)
    }

    function getFiltersCatalogs() {
      return ApplicationFactory.getFiltersCatalogs().then(
        ServiceUtils.handleResolve('data.catalogs')
      )
    }

    function getFiltersByType(filterId, searchFilters) {
      return ApplicationFactory.getFiltersByType(filterId, searchFilters).catch(
        ServiceUtils.handleError
      )
    }

    function getApplicationsByFilter(filters) {
      return ApplicationFactory.getApplicationsByFilter(filters)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function restoreBatch(apps) {
      return ApplicationFactory.restoreBatch(apps).catch(
        ServiceUtils.handleError
      )
    }

    function resetBatch(apps) {
      return ApplicationFactory.resetBatch(apps).catch(ServiceUtils.handleError)
    }

    function deleteBatch(apps) {
      return ApplicationFactory.deleteBatch(apps).catch(
        ServiceUtils.handleError
      )
    }

    function getAppGroups() {
      return ApplicationFactory.getAppGroups().catch(ServiceUtils.handleError)
    }

    function updateImportance(appId, form) {
      return ApplicationFactory.updateImportance(appId, form)
        .then(
          ServiceUtils.handleResolve('', { log: ServiceUtils.LOGGER.SUCCESS })
        )
        .catch(ServiceUtils.handleError)
    }

    function getApplicationsQuickFilters(filters) {
      return ApplicationFactory.getApplicationsQuickFilters(filters)
        .then(ServiceUtils.handleResolve('data.filters'))
        .catch(ServiceUtils.handleError)
    }

    function getShortApplicationsByFilter(filters) {
      return ApplicationFactory.getShortApplicationsByFilter(filters)
    }

    function launchTagApplicationsModal(applications) {
      var transl = {
        title_applications_tagApplications: $translate.instant(
          'title_applications_tagApplications'
        )
      }

      return $uibModal.open({
        templateUrl: 'views/tags/modal_tag.html',
        controller: 'ModalTagApplicationCtrl',
        size: 'sm',
        resolve: {
          applications: function () {
            return applications
          },
          title: function () {
            return transl.title_applications_tagApplications
          }
        }
      }).result
    }

    function launchAppGroupModal(apps) {
      return $uibModal.open({
        templateUrl: 'views/applications/modal_group.html',
        controller: 'AppGroupModalInstanceCtrl',
        resolve: {
          appgroups: function () {
            return getAppGroups()
          },
          selectedapps: function () {
            return apps
          }
        }
      }).result
    }

    function launchAppMergeModal(apps) {
      return $uibModal.open({
        templateUrl: 'views/applications/modal_merge.html',
        controller: 'AppMergeModalInstanceCtrl',
        windowClass: 'select-primary-app',
        resolve: {
          apps: function () {
            return apps
          }
        }
      }).result
    }

    function archivePrimaryApps(apps) {
      return $uibModal.open({
        templateUrl: 'views/applications/modal_archive_primary.html',
        controller: 'AppArchivePrimaryModalInstanceCtrl',
        resolve: {
          primaryApp: function () {
            return apps.pop()
          }
        }
      }).result
    }

    function archiveNormalApps(apps) {
      return $uibModal.open({
        templateUrl: 'views/applications/modal_archive.html',
        controller: 'AppArchiveModalInstanceCtrl',
        resolve: {
          applications: function () {
            return apps
          }
        }
      }).result
    }
  }
})()
